<template>
    <el-drawer title="设置售价" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">

                <!-- <el-form-item label="当前演出：">
                    {{data && data.activityName}}
                </el-form-item>
                <el-form-item prop="name" label="当前照片售价（元）：">
                    {{data && data.price}}
                </el-form-item> -->
                <div><span class="color-info">当前演出：</span>{{data && data.activityName}}</div>
                <div class="MT10"><span class="color-info">当前照片售价：</span>{{data && data.price}}元</div>
                <el-form-item prop="price" label="设置售价（元）：" class="MT20">
                    <el-input-number style="width:100%" :precision="2" v-model="formData.price" :min="0"
                        :max="99999999"></el-input-number>
                </el-form-item>
            </el-form>
            <el-alert type="warning" title="注意" :closable="false">
                已上传未售出的照片价格将更新为设置价格<br>已售出照片售价不变<br>新上传照片售价以最新设置为准
            </el-alert>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    activityId: "",
    price: undefined
}
export default {

    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            data: null,
            formData: {
                ...defaultData
            },
            rules: {
                price: [{ required: true, message: "请填写售价" }]
            }
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
            this.data = null;
        },
        show(data) {
            this.data = data;
            this.formData = {
                ...defaultData,
                activityId: data.activityId
            };
            this.drawerShow = true;
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/photo/setPrice',
                        params: {
                            ...this.formData,
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>